import { CloseOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"

import chipStyles from "../../chips.module.less"

// A value the merchant typed themselves, rendered in the selected-chip style with an
// inline remove button. Shared by the chip-multi "+ Other" additions and the
// text-multi list, which are the same affordance over different storage.
const RemovableChip = ({ label, onRemove, className = "" }) => {
  const { t } = useTranslation()
  return (
    <span
      className={`${chipStyles.chip} ${chipStyles.chipCustom} ${chipStyles.chipOn} ${className}`.trim()}
    >
      <span className={chipStyles.chipCustomText}>{label}</span>
      <button
        type="button"
        className={chipStyles.chipCustomX}
        aria-label={t("Remove _item_", { item: label })}
        onClick={(e) => {
          e.stopPropagation()
          onRemove()
        }}
      >
        <CloseOutlined />
      </button>
    </span>
  )
}

export default RemovableChip
